import { render } from "./PurchaseOutboxQueueList.vue?vue&type=template&id=2ebd9ba6"
import script from "./PurchaseOutboxQueueList.vue?vue&type=script&lang=js"
export * from "./PurchaseOutboxQueueList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__